<template>
  <v-row justify="center">
    <v-col md="8" cols="12">
      <base-dialog-form ref="viewOrderDialog" :title="$t('view_order')" :text="order ? order.text : ''" color="secondary"
        icon="mdi-file-document-outline">
        <template v-slot:actions>
          <v-row class="justify-center">
            <v-col cols="12" class="text-center">
              <v-btn v-if="RBAC_APPROVE && order && order.canApprove && order.status > 0
                " @click="approvePayment()" color="success" class="mx-5">
                <v-icon>mdi-thumb-up-outline</v-icon>
                <span>{{ $t("approve") }}</span>
              </v-btn>
              <v-btn v-if="RBAC_APPROVE && order && order.canReject && order.status > 0
                " @click="rejectPayment()" color="warning" class="mx-5">
                <v-icon>mdi-thumb-down-outline</v-icon>
                <span>{{ $t("reject") }}</span>
              </v-btn>
              <v-btn v-if="RBAC_EVADE && !evaso" @click="evadeFullOrder()" color="success" class="mx-5">
                <v-icon>mdi-cart-arrow-up</v-icon>
                <span>{{ $t("evade_order") }}</span>
              </v-btn>
              <v-btn v-if="order && order.canDelete && order.status > 0" @click="cancelOrder()" color="error"
                class="mx-5">
                <v-icon>mdi-delete</v-icon>
                <span>{{ $t("delete_order") }}</span>
              </v-btn>
              <v-btn v-if="order &&
                order.totale > 0 &&
                order.canRefoundCash &&
                order.status > 0
                " @click="cancelOrder('C')" color="warning" class="mx-5">
                <v-icon>mdi-delete</v-icon>
                <span>{{ $t("delete_refound_order") }}</span>
              </v-btn>
              <v-btn v-if="order &&
                order.totale > 0 &&
                order.canRefoundPoint &&
                order.status > 0
                " @click="cancelOrder('P')" color="warning" class="mx-5">
                <v-icon>mdi-delete</v-icon>
                <span>{{ $t("delete_voucher_order") }}</span>
              </v-btn>
            </v-col>
          </v-row>
        </template>
        <v-row v-if="order" align="end" justify="space-between">
          <v-col md="5" cols="12">
            <v-simple-table>
              <tbody>
                <tr>
                  <td>{{ $t("user") }}</td>
                  <td v-if="order.asdCode">
                    {{
                      (order.asdRagSoc ? order.asdRagSoc : order.asdCode) +
                      " (" +
                      order.userInfo.fullName +
                      ")"
                    }}
                  </td>
                  <td v-else>{{ order.userInfo.fullName }}</td>
                </tr>
                <tr>
                  <td>{{ $t("fiscal_code") }}</td>
                  <td>{{ order.userInfo.cFiscale }}</td>
                </tr>
                <tr>
                  <td>{{ $t("address") }}</td>
                  <td>
                    {{ order.userInfo.resStreet }} {{ order.userInfo.resCity }}
                    {{ order.userInfo.resCAP }} {{ order.userInfo.resProv }}
                  </td>
                </tr>
                <tr>
                  <td>{{ $t("email") }}</td>
                  <td>{{ order.userInfo.email }}</td>
                </tr>
                <tr>
                  <td>{{ $t("telephone") }}</td>
                  <td>{{ order.userInfo.telephone }}</td>
                </tr>
                <tr>
                  <td>{{ $t("attachments") }}</td>
                  <td>

                    <v-tooltip top v-if="order.totale > 0 && order.linkRicevuta">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon large v-bind="attrs" v-on="on" color="success" min-width="0" text
                          @click.native="openLink(order.linkRicevuta)">
                          <v-icon>mdi-piggy-bank-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t("receipt") }}</span>
                    </v-tooltip>

                    <v-tooltip top v-if="order.linkBiglietto">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon large v-bind="attrs" v-on="on" color="success" min-width="0" text
                          @click.native="openLink(order.linkBiglietto)">
                          <v-icon>mdi-ticket</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t("ticket") }}</span>
                    </v-tooltip>

                    <v-tooltip top v-if="order.linkTessera">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" icon large color="success" min-width="0" text
                          @click.native="openLink(order.linkTessera)">
                          <v-icon>mdi-card-account-details-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t("card") }}</span>
                    </v-tooltip>


                    <v-tooltip top v-if="order.linkDiploma">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" icon large color="success" min-width="0" text
                          @click.native="openLink(order.linkDiploma)">
                          <v-icon>mdi-certificate-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t("diploma") }}</span>
                    </v-tooltip>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>

          <v-col md="5" cols="12">
            <v-simple-table>
              <tbody>
                <tr>
                  <td>{{ $t("order_number") }}</td>
                  <td>
                    {{ order.orderId }} -
                    {{ new Date(order.date).toLocaleDateString() }}
                  </td>
                </tr>
                <tr>
                  <td>{{ $t("order_code") }}</td>
                  <td>
                    {{ order.orderCode }}
                  </td>
                </tr>

                <tr v-if="order.masterId != order.masterIdIns">
                  <td>{{ $t("created_by") }}</td>
                  <td>{{ order.userInsertInfo.fullName }}</td>
                </tr>
                <tr>
                  <td>{{ $t("payment_mode") }}</td>
                  <td v-if="order.pagato === 1 && order.forceOrderApprove !== 1">
                    {{
                      order && order.infoPag && order.infoPag.descr
                      ? order.infoPag.descr
                      : ""
                    }}
                  </td>
                  <td v-else-if="order.canModifyPag">
                    <v-select v-model="order.pagId" :items="listPayment" :menu-props="{ maxHeight: '400' }"
                      :label="$t('payments')" required color="primary" persistent-hint></v-select>
                  </td>
                  <td v-else-if="order.forceOrderApprove === 1">
                    <h3 class="error--text">
                      {{ $t("waiting_approval") }}
                    </h3>
                  </td>
                  <td v-else>
                    <h3 class="error--text">
                      {{ $t("waiting_payment") }}
                    </h3>
                  </td>
                </tr>
                <tr>
                  <td>{{ $t("payment_date") }}</td>
                  <td v-if="order.pagato === 1">
                    {{ new Date(order.datePag).toLocaleDateString() }}
                  </td>
                  <td v-else-if="order.canModifyPag">
                    <my-datepicker v-model="order.datePag" :label="$t('payment_date')" required="true" />
                  </td>
                  <td v-else-if="order.forceOrderApprove === 1">
                    <h3 class="error--text">
                      {{ $t("waiting_approval") }}
                    </h3>
                  </td>
                  <td v-else>
                    <h3 class="error--text">
                      {{ $t("waiting_payment") }}
                    </h3>
                  </td>
                </tr>
                <tr>
                  <td>{{ $t("status") }}</td>
                  <td>
                    <h3 :class="order.status <= 0 ? 'error--text' : 'success--text'
                      ">
                      {{ order.statusDex }}
                    </h3>
                  </td>
                </tr>

                <tr v-if="order.totale > 0 && order.status >= 3">
                  <td>{{ $t("cge_reg") }}</td>
                  <td>
                    <span v-if="order.numeCge">
                      {{ order.annoCge }}/{{ order.numeCge }}
                    </span>

                    <v-tooltip top v-if="!order.numeCge && this.RBAC_EDIT_CGE">
                      <template v-slot:activator="{ on }">
                        <v-btn icon large color="warning" min-width="0" text @click.native="createCge()">
                          <v-icon>mdi-cash-plus</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t("create_reg") }}</span>
                    </v-tooltip>

                    <v-tooltip top v-if="order.numeCge && this.RBAC_VIEW_CGE">
                      <template v-slot:activator="{ on }">
                        <v-btn icon large color="primary" min-width="0" text @click.native="showCge(false)">
                          <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t("view_reg") }}</span>
                    </v-tooltip>

                    <v-tooltip top v-if="order.numeCge && this.RBAC_EDIT_CGE">
                      <template v-slot:activator="{ on }">
                        <v-btn icon large color="primary" min-width="0" text @click.native="showCge(true)">
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t("edit_reg") }}</span>
                    </v-tooltip>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
          <v-col cols="12">
            <DataTables :showFooter="true" :showSearch="true" @evadeOrderLine="evadeOrderLine"
              @deleteOrderLine="deleteOrderLine" v-if="order && order.dettaglio" :headers="headers"
              :table-data="order.dettaglio" hide-default-footer class="elevation-1"></DataTables>
          </v-col>
        </v-row>
      </base-dialog-form>
    </v-col>
    <edit-cge ref="gestMovimentoDialog" @isUpdated="getOrder"></edit-cge>
  </v-row>
</template>

<script>
import Swal from "sweetalert2";
import MyDatepicker from "@/components/base/MyDatepicker.vue";
import DataTables from "@/components/base/DataTables.vue";
import gestMovimento from "@/app/contab/gestMovimento.vue";

export default {
  name: "view-order",
  components: {
    Swal,
    MyDatepicker,
    DataTables,
    "edit-cge": gestMovimento,
  },
  props: { paramsOrderId: null },
  data() {
    return {
      order: null,
      evaso: false,
      fullEvade: false,
      RBAC_EVADE: false,
      RBAC_EDIT_CGE: false,
      RBAC_VIEW_CGE: false,
      RBAC_APPROVE: false,
      listPayment: [],
      headers: [],
    };
  },
  methods: {
    showCge(edit) {
      if (edit)
        this.$refs.gestMovimentoDialog.open(
          "EDIT",
          this.order.annoCge,
          this.order.numeCge
        );
      else
        this.$refs.gestMovimentoDialog.open(
          "VIEW",
          this.order.annoCge,
          this.order.numeCge
        );
    },
    createCge() {
      const _ = this;
      this.chiamataAxios("PUT", "/auth/contab/contabOrder/" + _.orderId, {
        msg: "always",
        dialogLoader: true,
      }).then((response) => {
        if (response.msg.esito) {
          _.$emit("isContabilized", "true");
          _.getOrder();
        }
      });
    },
    openLink(link) {
      this.$documentViewer.documentViewerRsp.docUrl = link;
    },
    evadeOrderLine(item) {
      const _ = this;
      this.chiamataAxios("POST", "/auth/portal/setOrderEvaso/" + item.orderId, {
        body: { updLine: [{ riga: item.riga, qtaCon: item.qtaRic }] },
        msg: "always",
        dialogLoader: true,
      }).then((response) => {
        if (response.msg.esito) {
          _.$emit("isUpdated", "true");
          _.getOrder();
        }
      });
    },
    deleteOrderLine(item) {
      const _ = this;
      Swal.fire({
        title: this.$t("are_you_sure_?"),
        type: "warning",
        html: this.$t("you_cant_revert_this"),
        showCancelButton: true,
        customClass: "v-application",
        confirmButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        cancelButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        confirmButtonText: this.$t("yes_delete"),
        cancelButtonText: this.$t("back"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.chiamataAxios("DELETE", "/auth/portal/cancelOrderLine/" + item.orderId + "/" + item.riga, {
            msg: "always",
            dialogLoader: true,
          }).then((response) => {
            if (response.msg.esito) {
              _.$emit("isUpdated", "true");
              _.getOrder();
            }
          });
        }
      });
    },
    getOrder() {
      let _ = this;
      _.evaso = true;
      _.listPayment = [];
      _.chiamataAxios("GET", "/auth/portal/listAllModPagamento").then(
        (response) => {
          _.listPayment = response.data
            .filter((pag) => {
              return pag.attivo === 1;
            })
            .map(function (item) {
              return { value: item.pagId, text: item.descr };
            });
        }
      );

      let url = "/auth/portal/getOrder/" + _.orderId;
      _.headers = [
        { text: _.$t("text"), value: "text", type: "html" },
        { text: _.$t("options"), value: "options", type: "jsonObj" },
        { text: _.$t("quantity"), value: "qtaConDex", type: "string" },
        { text: _.$t("price"), value: "prezzo", type: "valuta" },
        { text: _.$t("discount"), value: "sconto", type: "valuta" },
        { text: _.$t("total"), value: "totale", type: "valuta" },
      ];
      _.chiamataAxios("GET", url).then((response) => {
        _.order = response.data;
        let canDeleteLine = _.order.canDelete && _.order.dettaglio.length > 1
        let showButton = false;
        _.order.dettaglio = _.order.dettaglio.map((item) => {
          if (item.qtaCon !== item.qtaRic) {
            _.evaso = false;
            item.qtaConDex = item.qtaCon + "/" + item.qtaRic;
            if (_.RBAC_EVADE) {
              showButton = true;
              item.bottoni = [
                {
                  icon: "mdi-cart-arrow-up",
                  function: "evadeOrderLine",
                  text: _.$t("evade_order_line"),
                  color: "success",
                },
              ];
            }
          } else item.qtaConDex = item.qtaRic;
          if (canDeleteLine && _.order.status > 0) {
            showButton = true;
            item.bottoni = [
              {
                icon: "mdi-trash-can",
                function: "deleteOrderLine",
                text: _.$t("delete_order_line"),
                color: "error",
              },
            ];

          }
          return item;
        });
        if (showButton) {
          _.headers.push({
            text: _.$t("options"),
            value: "bottoni",
            type: "buttons",
          });
        }
        _.$refs.viewOrderDialog.open();
      });
    },
    approvePayment(item) {
      const _ = this;
      this.chiamataAxios(
        "POST",
        "/auth/portal/approveOrderPayment/" + _.orderId,
        {
          body: { pagId: _.order.pagId, datePag: _.order.datePag },
          msg: "always",
          dialogLoader: true,
        }
      ).then((response) => {
        if (response.msg.esito) {
          _.$emit("isUpdated", "true");
          _.$refs.viewOrderDialog.close();
        }
      });
    },
    evadeFullOrder(item) {
      const _ = this;
      this.chiamataAxios("POST", "/auth/portal/setOrderEvaso/" + _.orderId, {
        body: { all: true },
        msg: "always",
        dialogLoader: true,
      }).then((response) => {
        if (response.msg.esito) {
          _.$emit("isUpdated", "true");
          _.$refs.viewOrderDialog.close();
        }
      });
    },
    rejectPayment(item) {
      const _ = this;
      this.chiamataAxios("DELETE", "/auth/portal/cancelOrder/" + _.orderId, {
        msg: "always",
        dialogLoader: true,
      }).then((response) => {
        if (response.msg.esito) {
          _.$emit("isUpdated", "true");
          _.$refs.viewOrderDialog.close();
        }
      });
    },
    cancelOrder(mode) {
      let _ = this;
      let text = this.$t("delete_order");
      if (mode === "C") text = this.$t("delete_refound_order");
      if (mode === "P") text = this.$t("delete_voucher_order");
      Swal.fire({
        title: this.$t("are_you_sure_?"),
        type: "warning",
        html: this.$t("you_cant_revert_this") + ":<br><br>" + text + "<br>",
        showCancelButton: true,
        customClass: "v-application",
        confirmButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        cancelButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        confirmButtonText: this.$t("yes_delete"),
        cancelButtonText: this.$t("back"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.chiamataAxios(
            "DELETE",
            "/auth/portal/cancelOrder/" + _.orderId + "/" + mode,
            { msg: "always", dialogLoader: true }
          ).then((response) => {
            if (response.msg.esito) {
              _.$emit("isDeleted", "true");
              _.$refs.viewOrderDialog.close();
            }
          });
        }
      });
    },
    open(orderId) {
      this.orderId = orderId;
      this.getOrder();
    },
  },
  watch: {
    paramsOrderId: function (newVal, oldVal) {
      // watch it
      if (newVal !== null) {
        this.orderId = this.paramsOrderId;
        this.getOrder();
      }
    },
  },
  mounted() {
    this.RBAC_EDIT_CGE = false;
    this.RBAC_VIEW_CGE = false;
    if (this.checkEnabledModule("contab")) {
      this.RBAC_EDIT_CGE = this.checkUserRole("contab", "EDIT_CGE");
      this.RBAC_VIEW_CGE = this.checkUserRole("contab", "VIEW_CGE");
    }
    this.RBAC_EVADE = this.checkUserRole("order", "EVADE");
    this.RBAC_APPROVE = this.checkUserRole("order", "APPROVE_PAYMENT");
  },
};
</script>